module.exports = __webpack_public_path__ + "img/bg.4d7b47f4.jpeg";